
















































































































import { fetchRegistrar } from '../fetchRegistrar';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment, { relativeTimeRounding } from 'moment';
import Vue from 'vue';
import { AxiosVue } from '@/AxiosVue'; //
import { ServicioProxy } from '@/config/enums'; //
import config from '@/config/index'; //
import { ComponenteBaseStepper } from '@/views/base/ComponenteBaseStepper';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';
import { EstadoInterface } from '@/interfaces/Estado';
import { LoadingService } from '@/services/loadingService';
import { EstadoEntidad } from '@/config/enums';
import { EstadosService } from '@/services/estadosService';
import { Validator } from 'vee-validate';
import { PermisoAccionVm } from '@/views/base/PermisoAccionVm';
import { Funcionalidades } from '@/config/funcionalidades';
import { CodigoAccion } from '@/views/base/VariablesPermisos';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { AccionesInterface, IAccionesPadre } from '@/interfaces/Acciones';
const { AgGridVue } = require('ag-grid-vue');
import {
  GridApi,
  ColumnApi,
  ColDef,
  CellContextMenuEvent,
  GridReadyEvent,
  SelectionChangedEvent,
  SelectionController,
  RowNode,
  CellClickedEvent,
  RowSelectedEvent,
  CellClassParams,
} from 'ag-grid-community';
import { differenceBy } from 'lodash';
import Confirmation from '@/components/Confirmation.vue';
import General from './General.vue';
import Solicitudes from './Solicitudes.vue';
import SimsSolicitudes from './SimsSolicitudes.vue';

@Component({
  components: {
    DatePicker,
    'ag-grid-vue': AgGridVue,
    'app-confirmacion': Confirmation,
    General,
    Solicitudes,
    SimsSolicitudes,
  },
})
export default class ProcesarSeleccion extends ComponenteBaseStepper {
  @Prop({ required: true }) solicitudesSelected: any;
  desactivar: boolean = true;
  pasoSolicitudes: any;
  estadoSelected: any;

  cambioEstado(data: any) {
    this.estadoSelected = data;
    this.desactivar = !data;
  }

  mounted() {
    this.pasoSolicitudes = this.$refs.SimsSolicitudes;
  }

  async procesarSeleccion(): Promise<boolean> {
    let self = this;
    return fetchRegistrar(
      {
        solicitudes: this.solicitudesSeleccionadas,
        usuario: JSON.parse(window.localStorage.user).id,
        estado: this.estadoSelected,
      },
      'conecta_registra_baja_sim/procesar_seleccion'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success('Solicitudes procesadas con éxito', {
            timeout: 3000,
          });
          return true;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return false;
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error al procesar la selección', {
          timeout: 3000,
        });
        return false;
      });
  }

  nextGeneral() {
    !this.generalMovi.visible;
    !this.sims.visible;
    this.e1 = 2;
    this.actual++;
    this.pasoSolicitudes.cargarSims();
  }

  solicitudesSeleccionadas: Array<any>;
  async CrearSolicitud(data: string) {
    let procesar = false;
    if (data == 'previous') {
      !this.generalMovi.visible;
      !this.sims.visible;
      this.e1--;
      this.actual--;
    } else {
      this.solicitudesSeleccionadas = this.solicitudesSelected.map(
        (solicitud: any) => {
          return Number(solicitud.sbajasimnumero);
        }
      );
      procesar = await this.procesarSeleccion();
      if (procesar) {
        this.confirmCallbackConfirm(true);
        this.$emit('actualizar', true);
      }
    }
  }

  permisosActuales: PermisoAccionVm[] = [];
  // Declarar todas las posibles subAcciones
  generalMovi: PermisoAccionVm = {
    accion: 'General',
    visible: true,
    step: 1,
    codigoAccionPadre: CodigoAccion.Crear,
  };

  sims: PermisoAccionVm = {
    accion: 'Sims',
    visible: false,
    step: 2,
    codigoAccionPadre: CodigoAccion.Crear,
  };

  permisosTotales: PermisoAccionVm[] = [this.generalMovi, this.sims];

  // Globales
  $snotify: any;
  e1: number = 1;
  actual: number = 1;
  btnClass: string = 'btn-continuar';
  dialog: boolean = true;
  validForm: boolean = true;
  loadingService = new LoadingService();
  btnBloquear: boolean = false;
  dialogConfirmacion: boolean = false;
  dialogConfirmacionClose: boolean = false;

  //Interface
  editedItem: IFuncionalidad = {};

  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'ModuloAccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  closeModal(val: boolean) {
    document.getElementById('cardDivModulos').scrollIntoView(true);
    this.editedItem = {};
    this.e1 = 1;
    this.$emit('modalAsociacionEmit', false);
    this.dialog = false;
    this.btnClass = 'btn-continuar';
  }

  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = false;
    if (val) {
      this.closeModal(false);
    }
  }

  cierraMenu() {
    var appBanners = document.getElementsByClassName(
      'ag-menu'
    ) as HTMLCollectionOf<HTMLElement>;
    if (appBanners.length > 0) {
      appBanners[0].remove();
    }
  }
}
